import React from "react";
import { useContent } from "../contexts/ContentContext";
import { resolveAssetUrl } from "../lib/api";

export default function About() {
    const { t, content } = useContent();
    const year = new Date().getFullYear();
    const since = 2000;
    const years = year - since;
    const side = resolveAssetUrl(content?.gallery_images?.[0]?.url);

    return (
        <section id="about" className="relative py-24 md:py-40 px-4 sm:px-6 lg:px-8" data-testid="about-section">
            <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 md:gap-16 items-center">
                <div className="lg:col-span-7">
                    <span className="kicker" data-testid="about-kicker">{t?.about?.kicker}</span>
                    <h2 className="mt-6 font-display text-4xl md:text-5xl lg:text-6xl font-normal text-brand-navy leading-[1.05]" data-testid="about-title">
                        {t?.about?.title}
                    </h2>
                    <p className="mt-8 text-base md:text-lg leading-[1.8] text-slate-600 max-w-2xl" data-testid="about-body">
                        {t?.about?.body}
                    </p>
                    <div className="mt-12 flex items-end gap-5 border-t border-brand-navy/10 pt-8 max-w-sm">
                        <span className="font-display text-7xl md:text-8xl text-brand-navy leading-none" data-testid="about-years">
                            {years}
                        </span>
                        <div className="pb-3">
                            <div className="font-display text-2xl text-brand-navy">{t?.about?.years}</div>
                            <p className="text-xs uppercase tracking-[0.2em] text-brand-blue mt-1">
                                {t?.about?.years_label}
                            </p>
                        </div>
                    </div>
                </div>
                <div className="lg:col-span-5 relative">
                    <div className="relative aspect-[4/5] rounded-2xl overflow-hidden shadow-2xl">
                        {side && <img src={side} alt="Zarautz" className="absolute inset-0 w-full h-full object-cover" />}
                        <div className="absolute inset-0 bg-gradient-to-t from-brand-navy/20 via-transparent to-transparent" />
                    </div>
                    <div className="absolute -bottom-6 -left-6 w-32 h-32 rounded-2xl bg-brand-terracotta hidden md:block -z-10" />
                    <div className="absolute -top-6 -right-6 w-24 h-24 rounded-2xl border-2 border-brand-blue hidden md:block -z-10" />
                </div>
            </div>
        </section>
    );
}
